module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-down-98b954bdfed5567cf3cf64a995585f08.svg";